// Local queue visibility must not depend on a successful network refresh.
export async function restoreQueueState(read, stillCurrent, display) {
    const saved = await read();
    if (stillCurrent())
        display(saved);
}
